<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Shipment No</th>
							<td>
								<input type="text" v-model.trim="shipment.sh_dn" class="tbl_int ssm2_int" :readonly="mode == 'detail'" :disabled="mode == 'detail'" />
								<template v-if="shipment.received_yn == 'Y'"> (<span v-if="shipment.total_quantity > 0 && shipment.total_quantity == shipment.received_quantity">All </span>Received)</template>
								<template v-if="shipment.closed_yn == 'Y'"> (Closed)</template>
							</td>
							<th>Loading Port</th>
							<td><CodeSelect className="tbl_select" :codes="importLocations" v-model="shipment.loading_port_code" /></td>
						</tr>
						<tr>
							<th>Application Date</th>
							<td>
								<CustomDatePicker v-model="shipment.application_date" />
							</td>
							<th>Arrival Port</th>
							<td><CodeSelect className="tbl_select" :codes="importLocations" v-model="shipment.arrival_port_code" /></td>
						</tr>
						<tr>
							<th>Vendor</th>
							<td>
								<div style="float:left;"><PartnerSelect v-model="shipment.vendor_code" :initialName="shipment.vendor_name" ph="Vendor" :showName="true" :vendorOnly="true" :limitRecentPO="true" @set-partner="setVendor" /></div>
							</td>
							<th>Delivery Place</th>
							<td><CodeSelect className="tbl_select" :codes="importLocations" v-model="shipment.delivery_place_code" /></td>
						</tr>
						<tr>
							<th>Delivery Type</th>
							<td><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="shipment.po_delivery_type_code" /></td>
							<th>LC No</th>
							<td><input type="text" v-model.trim="shipment.lc_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Trade Term</th>
							<td><CodeSelect className="tbl_select" :codes="tradeTerms" v-model="shipment.trade_term_code" /></td>
							<th>LC Bank</th>
							<td><CodeSelect className="tbl_select" :codes="banks" v-model="shipment.lc_bank_code" /></td>
						</tr>
						<tr>
							<th>Carton</th>
							<td><currency-input type="text" v-model="shipment.carton" :precision="0" class="tbl_int ssm_int al_right" /></td>
							<th>Shipment Date</th>
							<td><CustomDatePicker v-model="shipment.shipment_date" /></td>
						</tr>
						<tr>
							<th>Qty/Amt (Received)</th>
							<td>
								<currency-input type="text" v-model="shipment.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-model="shipment.total_amount" class="tbl_int ssm_int al_right" readonly />
								(<currency-input type="text" v-model="shipment.received_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly /> <currency-input type="text" v-model="shipment.received_amount" class="tbl_int ssm_int al_right" readonly />)
							</td>
							<th>Arrival / ETA Date</th>
							<td><CustomDatePicker v-model="shipment.arrival_date" /></td>
						</tr>
						<tr>
							<th>Description</th>
							<td><input type="text" v-model.trim="shipment.description" class="tbl_int" /></td>
							<th>BL No</th>
							<td><input type="text" v-model.trim="shipment.bl_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Remark</th>
							<td><input type="text" v-model.trim="shipment.remark" class="tbl_int" /></td>
							<th>Container No</th>
							<td><input type="text" v-model.trim="shipment.container_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Receipt Date</th>
							<td>
								<CustomDatePicker v-model="shipment.received_date" />
								<label v-if="user.company_id != 'hairplus'" for="closed_yn" style="margin-left:25px;"> <input type="checkbox" id="closed_yn" v-model="shipment.closed_yn" true-value="Y" false-value="N" />Closed</label>
							</td>
							<th v-if="user.company_id == 'jc'">Vendor Invoice No</th>
							<th v-else></th>
							<td><input v-if="user.company_id == 'jc'" type="text" v-model.trim="shipment.vendor_invoice_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr v-if="user.company_id == 'hairplus'">
							<th>Payment</th>
							<td>
								<select v-model="payment_status" class="tbl_select sm_int">
									<option value="">-</option>
									<option value="PAID">지급 완료</option>
									<option value="UNPAID">미지급</option>
									<option value="OTHERS">Others</option>
								</select>
								<input type="text" v-model.trim="payment_memo" placeholder="Memo" class="tbl_int" style="margin-left:10px; width:400px;" />
							</td>
							<th>CBP Tariff</th>
							<td>
								<currency-input type="text" v-model="shipment.cbp_duty" class="tbl_int ssm_int al_right" />
								<select v-model="cbp_duty_sel" class="tbl_select sm_int" style="margin-left:6px;">
									<option value="">-</option>
									<option value="COMPLETED">완료</option>
									<option value="OTHERS">Others</option>
								</select>
								<input type="text" v-model.trim="cbp_duty_memo" placeholder="Memo" class="tbl_int" style="margin-left:6px; width:160px;" />
							</td>
						</tr>
						<tr v-if="user.company_id == 'hairplus'">
							<th></th>
							<td></td>
							<th>Shipping Cost</th>
							<td>
								<currency-input type="text" v-model="shipment.shipping_cost" class="tbl_int ssm_int al_right" />
								<select v-model="shipping_cost_sel" class="tbl_select sm_int" style="margin-left:6px;">
									<option value="">-</option>
									<option value="COMPLETED">완료</option>
									<option value="UNPAID">미지급</option>
									<option value="OTHERS">Others</option>
								</select>
								<input type="text" v-model.trim="shipping_cost_memo" placeholder="Memo" class="tbl_int" style="margin-left:6px; width:160px;" />
							</td>
						</tr>
						<tr v-if="user.company_id == 'hairplus'">
							<th>Closed</th>
							<td>
								<label for="closed_yn"><input type="checkbox" id="closed_yn" v-model="shipment.closed_yn" true-value="Y" false-value="N" />Closed</label>
							</td>
							<th>Landed Cost</th>
							<td>
								<currency-input type="text" :value="landed_cost" class="tbl_int ssm_int al_right" readonly />
								<span style="margin-left:8px; color:#888;">= Rcvd Amt + CBP + Shipping</span>
							</td>
						</tr>
						<tr v-if="user.admin_yn == 'Y'">
							<td colspan="4">Created : {{ shipment.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ shipment.crt_user }}, Last updated : {{ shipment.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ shipment.upd_user }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- New Item -->
			<div class="left_option" style="padding-bottom:4px;">
				<a href="javascript:;" class="search_bt" @click="search()">Search and Add Item(s) from Purchase Order</a>
			</div>

			<table class="list_tbl mgb_0 add_top_line" ref="shipment_items">
				<thead>
					<tr>
						<th width="30px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
						<th width="120px;">{{ headers.class }}</th>
						<th>Name</th>
						<th width="100px;" v-if="user.company_id == 'he'">Rack</th>
						<th width="45px;" v-if="user.company_id == 'newjigu'">New Style</th>
						<th width="45px;" v-if="user.company_id == 'newjigu'">New Color</th>
						<th width="120px;" v-if="user.company_id != 'jc'">Color</th>
						<th width="80px;">Price</th>
						<th width="50px;" v-if="user.company_id == 'jc'">U/M</th>
						<th width="60px;" v-if="user.company_id == 'jc'">QTY/CTN</th>
						<th width="120px;" v-if="user.company_id == 'jc'">P.cost</th>
						<th width="80px;">Qty</th>
						<th width="80px;">Amount</th>
						<th width="80px;">{{ user.company_id == 'jc' ? 'STD cost' : 'FOB Cost' }}</th>
						<th width="80px;" v-if="user.company_id != 'jc'">FOB Amount</th>
						<th v-if="user.company_id == 'jc'" width="80px;">Warehouse</th>
						<th width="80px;">Rcvd Qty</th>
						<th width="80px;">Rcvd Amt</th>
						<th width="80px;">PO No</th>
						<th width="80px;" v-if="user.company_id != 'jc'">PO Price</th>
						<th width="80px;">PO Qty</th>
						<th width="80px;" v-if="user.company_id != 'jc'">PO Amount</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(item, index) in items"
						v-bind:key="item.sh_item_no"
						v-bind:class="{
							same: item.org_received_quantity > 0,
						}"
					>
						<td class="al_center"><input type="checkbox" v-model="item.selected" :disabled="item.org_received_quantity > 0" /></td>

						<td class="al_left">
							{{ item.class_code }}<span v-if="item.class_so_blocked">&nbsp;<font color="red">Blocked</font></span>
						</td>
						<td class="al_left">
							<a href="javascript:;" @click="selectItem(item)">{{ item.item_name }}</a>
						</td>
						<td v-if="user.company_id == 'he'" class="al_left">{{ item.rack }}</td>
						<td v-if="user.company_id == 'newjigu'" class="al_center">
							<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
								<input type="checkbox" v-model="item.new_style" />
							</template>
							<!-- <input type="checkbox" v-model="item.new_style" /> -->
						</td>
						<td v-if="user.company_id == 'newjigu'" class="al_center"><input type="checkbox" v-model="item.new_color" /></td>
						<td v-if="user.company_id != 'jc'" class="al_left">{{ item.color_code }}</td>
						<td class="al_right">
							<currency-input
								v-if="user.company_id != 'jc'"
								type="text"
								v-model="item.unit_price"
								:precision="profile.po_decimal_point"
								class="r_int long_type al_right"
								ref="unit_price"
								@focus="$event.target.select()"
								@keydown.down.prevent="goTo('unit_price', index + 1)"
								@keydown.up.prevent="goTo('unit_price', index - 1)"
								@keydown.right.prevent="goTo('quantity', index)"
								@keydown.left.prevent="goTo('received_quantity', index - 1)"
							/>
							<span v-else>{{ sellingPriceText(item) }}</span>
						</td>
						<td v-if="user.company_id == 'jc'" class="al_center">{{ item.purchase_unit_code }}</td>
						<td v-if="user.company_id == 'jc'" class="al_right">{{ item.packing | commaSeparated }}</td>
						<td v-if="user.company_id == 'jc'" class="al_right" style="min-width: 120px;">
							<currency-input
								:value="purchaseCost(item)"
								:precision="3"
								ref="unit_price"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								@input="editPurchaseCost(index, $event)"
								@keydown.down.prevent="goTo('unit_price', index + 1)"
								@keydown.up.prevent="goTo('unit_price', index - 1)"
								@keydown.left.prevent="goTo('quantity', index)"
								@keydown.right.prevent="goTo('fob_price', index)"
							/>
						</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model.trim="item.quantity"
								:precision="0"
								class="r_int long_type al_right"
								ref="quantity"
								@focus="$event.target.select()"
								:valueRange="item.remaining_quantity ? { max: item.remaining_quantity } : {}"
								@keydown.down.prevent="goTo('quantity', index + 1)"
								@keydown.up.prevent="goTo('quantity', index - 1)"
								@keydown.right.prevent="goTo('fob_price', index)"
								@keydown.left.prevent="goTo('unit_price', index)"
							/>
						</td>
						<td class="al_right">{{ item.amount | toPOCurrency(profile.po_decimal_point) }}</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model="item.fob_price"
								:precision="profile.po_decimal_point"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="fob_price"
								:style="item.im_fob != item.fob_price ? 'color:red;' : 'color:black'"
								@keydown.down.prevent="goTo('fob_price', index + 1)"
								@keydown.up.prevent="goTo('fob_price', index - 1)"
								@keydown.right.prevent="goTo('received_quantity', index + 1)"
								@keydown.left.prevent="goTo('unit_price', index)"
								@input="priceInputEvent2(index, item.class_code, item.cost, $event)"
							/>
						</td>
						<td class="al_right" v-if="user.company_id != 'jc'">{{ item.fob_amount | toPOCurrency(profile.po_decimal_point) }}</td>
						<td v-if="user.company_id == 'jc'" class="al_right">
							<select v-model="item.location_code" class="tbl_select font_12">
								<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
							</select>
						</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model.trim="item.received_quantity"
								:precision="0"
								class="r_int long_type al_right"
								ref="received_quantity"
								@focus="$event.target.select()"
								@keydown.down.prevent="goTo('received_quantity', index + 1)"
								@keydown.up.prevent="goTo('received_quantity', index - 1)"
								@keydown.right.prevent="goTo('unit_price', index + 1)"
								@keydown.left.prevent="goTo('quantity', index)"
								:disabled="mode == 'add'"
							/>
						</td>

						<td class="al_right">{{ item.received_amount | toPOCurrency(profile.po_decimal_point) }}</td>
						<td class="al_left">
							<a href="javascript:;" @click="selectPurchase(item)" style="margin-left:5px;">{{ item.po_dn }}</a>
						</td>
						<td class="al_right" v-if="user.company_id != 'jc'">{{ item.po_unit_price | toPOCurrency(profile.po_decimal_point) }}</td>
						<td class="al_right">{{ item.po_quantity | commaSeparated }}</td>
						<td class="al_right" v-if="user.company_id != 'jc'">{{ item.po_amount | toPOCurrency(profile.po_decimal_point) }}</td>
					</tr>
					<tr>
						<td :colspan="user.company_id == 'newjigu' ? 6 : user.company_id == 'he' ? 5 : user.company_id == 'jc' ? 3 : 4" class="al_right"><font color="red">Total</font></td>
						<td></td>
						<td v-if="user.company_id == 'jc'"></td>
						<td v-if="user.company_id == 'jc'"></td>
						<td v-if="user.company_id == 'jc'"></td>
						<td class="al_right" style="padding-right:8px;">
							<font color="red">{{ item_sum.total_quantity | commaSeparated }}</font>
						</td>
						<td class="al_right">
							<font color="red">{{ item_sum.total_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
						<td></td>
						<td class="al_right" v-if="user.company_id != 'jc'">
							<font color="red">{{ item_sum.total_fob_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
						<td v-if="user.company_id == 'jc'"></td>
						<td class="al_right" style="padding-right:8px;">
							<font color="red">{{ item_sum.total_received_quantity | commaSeparated }}</font>
						</td>
						<td class="al_right">
							<font color="red">{{ item_sum.total_received_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
						<td></td>
						<td v-if="user.company_id != 'jc'"></td>
						<td class="al_right">
							<font color="red">{{ item_sum.total_po_quantity | commaSeparated }}</font>
						</td>
						<td class="al_right" v-if="user.company_id != 'jc'">
							<font color="red">{{ item_sum.total_po_amount | toPOCurrency(profile.po_decimal_point) }} </font>
						</td>
					</tr>
				</tbody>
			</table>

			<div class="tbl_bottom_bt">
				<input type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<input type="button" value="All Receive" class="int_line_bt" style="margin-left:10px;" @click="receiveAllItems()" />
				<input type="button" value="All Receive Cancel" class="int_line_bt" style="margin-left:10px;" @click="cancelAllItems()" />
				<input type="button" value="B/O Info." class="int_line_bt" style="margin-left:10px;" @click="gotoBackOrder()" />
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />
			</div>

			<div class="view_bottom_bt">
				<a v-if="shipment.sh_no" href="javascript:;" type="button" class="gray_bt fl_l mgr_5" @click="reportPrint">Print</a>
				<a v-if="shipment.sh_no" href="javascript:;" type="button" class="gray_bt fl_l" @click="excelExport()">Excel</a>

				<a href="javascript:;" type="button" class="gray_bt fl_l mgl_15" @click="adjustCosts">Adjust Cost / FOB to Item Master's</a>

				<a v-if="blocked_item_exists" href="javascript:;" type="button" class="gray_bt mgr_15" @click="unblock()">UnBlock</a>
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>

				<a v-if="modifiable && mode == 'detail' && shipment.received_yn == 'N'" href="javascript:;" type="button" class="gray_bt mgl_15 mgr_15" @click="del()">Delete</a>

				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Cancel</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemSelect'" :draggable="false">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<PoItemPopup :initialVendorCode="shipment.vendor_code" :initialSortKey="'po_dn'" v-on:close="closeModal()" @set-items="addItems" :already_selected_items="items" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
//import { apiSelectPartner } from '@/api/partner/index.js';
import { apiIndex, apiSelectShipment, apiInsertShipment, apiUpdateShipment, apiDeleteShipment, apiCheckShipmentExists, apiSelectShipmentItemList } from '@/api/purchase/shipment.js';
import { apiUpdateSoBlockItemClasses } from '@/api/item/class.js';
import { apiGetReportTemplate, Report, reportMrtUrl, companyMrtUrl, exportDataExcel, getUpdateInfo } from '@/api/util';
import { today } from '@/utils/date.js';
import { defaultDataType } from 'export-xlsx';

import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PoItemPopup from '@/components/common/PoItemPopup';
import Modal from '@/components/common/Modal';

import 'floatthead';

import { initializeJcItem, initializeJcHeader, purchaseCost, sellingPriceText, setPurchaseCost, applySellingCost, recalculateJc, validateJcPrices } from '@/utils/jcPurchasePricing';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/purchase/shipment_main',
			mode: 'add',
			shipment: {
				sh_dn: null,
			},
			payment_status: '',
			payment_memo: '',
			cbp_duty_sel: '',
			cbp_duty_memo: '',
			shipping_cost_sel: '',
			shipping_cost_memo: '',
			items: [],
			item_nos_to_delete: [],

			// paymentTerms: [],
			tradeTerms: [],
			deliveryTypes: [],
			banks: [],
			importLocations: [],
			locations: [],
			// paymentTypes: [],
			// holdTypes: [],

			remark: null,

			allSelected: false,

			itemClass: null,
			keyword: '',
			searchItems: [],
			// salesTeams: [],

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],

			modalName: '',
			showModal: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		item_sum: function() {
			var s = { total_quantity: 0, total_amount: 0, total_fob_amount: 0, total_received_quantity: 0, total_received_amount: 0, total_po_quantity: 0, total_po_amount: 0 };

			this.items.forEach(i => {
				if (i.quantity) s.total_quantity += i.quantity;
				if (i.amount) s.total_amount += i.amount;
				if (i.fob_amount) s.total_fob_amount += i.fob_amount;
				if (i.received_quantity) s.total_received_quantity += i.received_quantity;
				if (i.received_amount) s.total_received_amount += i.received_amount;
				if (i.po_quantity) s.total_po_quantity += i.po_quantity;
				if (i.po_amount) s.total_po_amount += i.po_amount;
			});
			return s;
		},
		blocked_item_exists() {
			if (this.items.filter(i => i.class_so_blocked).length > 0) return true;
			return false;
		},
		landed_cost: function() {
			var a = Number(this.shipment.received_amount) || 0;
			var b = Number(this.shipment.cbp_duty) || 0;
			var c = Number(this.shipment.shipping_cost) || 0;
			return a + b + c;
		},
	},
	watch: {
		shipment: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	components: {
		PartnerSelect,
		//Modal,
		CodeSelect,
		CustomDatePicker,
		//ItemClassSelect,
		PoItemPopup,
		Modal,
	},
	methods: {
		purchaseCost,
		sellingPriceText,
		editPurchaseCost(index, value) {
			setPurchaseCost(this.items[index], value);
		},
		adjustCosts() {
			this.items.forEach(i => {
				if (this.user.company_id == 'jc') applySellingCost(i, i.im_cost);
				else i.unit_price = i.im_cost;
				i.fob_price = i.im_fob;
			});
		},
		priceInputEvent2(index, class_code, cost, fob_price) {
			//console.log(index, class_code, cost, price);
			for (var i = index + 1; i < this.items.length; i++) {
				if (this.items[i].class_code == class_code) {
					this.items[i].fob_price = fob_price + this.items[i].cost - cost;
				}
			}
		},
		async unblock() {
			var blockedClasses = [];
			this.items
				.filter(i => i.class_so_blocked)
				.forEach(i => {
					blockedClasses.push({ code: i.class_code });
				});

			const { data } = await apiUpdateSoBlockItemClasses({
				item_class_list: blockedClasses,
				so_blocked: 0,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.items
					.filter(i => i.class_so_blocked)
					.forEach(i => {
						i.class_so_blocked = false;
					});
			} else {
				this.$toast.error(data.msg);
			}
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Shipment No');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckShipmentExists(this.shipment);
			return data.result;
		},
		async reportPrint() {
			if (!this.shipment.sh_no) return this.$toast.error('No Data To Be Shown');

			const data = { shipment: this.shipment, shipmentItemList: this.items };
			if (this.user.company_id == 'he') {
				data.shipmentItemList.forEach(si => {
					si.name = si.rack ? si.rack + ' - ' + si.name : si.name;
				});
			}
			const mrt_url = this.user.company_id === 'jc' ? companyMrtUrl('ShipmentDetail') : reportMrtUrl('ShipmentDetail');
			const reportTemplate = await apiGetReportTemplate('ShipmentDetail', mrt_url);
			const report = new Report(reportTemplate, data, 'ShipmentDetail');
			this.$store.commit('setReport', report);
		},
		async excelExport() {
			if (!this.shipment.sh_no) return;

			const { data } = await apiSelectShipmentItemList({ sh_no: this.shipment.sh_no });
			const shipmentItemList = data.shipmentItemList;
			if (!(shipmentItemList && shipmentItemList.length)) {
				this.$toast.error('No Data to Export.');
				return;
			}

			const filename = 'SH_' + this.shipment.sh_dn;

			const headers = [
				{ key: 'class_code', name: this.headers.class + ' Code', width: 20, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item Code', width: 30, dataType: defaultDataType.string },
				{ key: 'item_name', name: 'Item Name', width: 30, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'unit_price', name: 'Price', width: 15, dataType: defaultDataType.number },
				{ key: 'quantity', name: 'Shipped Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'amount', name: 'Shipped Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'received_quantity', name: 'Rcvd. Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'received_amount', name: 'Rcvd. Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'po_dn', name: 'PO No.', width: 10, dataType: defaultDataType.string },
				{ key: 'po_unit_price', name: 'PO Price', width: 15, dataType: defaultDataType.number },
				{ key: 'po_quantity', name: 'PO Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'po_amount', name: 'PO Amt.', width: 15, dataType: defaultDataType.number },
			];
			if (this.user.company_id == 'he') {
				headers.splice(3, 0, { key: 'rack', name: 'Rack', width: '15', dataType: defaultDataType.string });
			}

			if (this.user.company_id == 'jc') {
				// #3128: JC 화면에서 PO Price/PO Amount 숨김과 일관되게 export에서도 제외
				for (const k of ['po_unit_price', 'po_amount']) {
					const idx = headers.findIndex(h => h.key === k);
					if (idx > -1) headers.splice(idx, 1);
				}
			}
			exportDataExcel(shipmentItemList, headers, filename);
		},
		async del() {
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteShipment(this.shipment);
				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.$router.push(this.backUri);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		goTo(colType, index) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					if (colType == 'unit_price') this.$refs.unit_price[index].$el.select();
					else if (colType == 'quantity') this.$refs.quantity[index].$el.select();
					else if (colType == 'fob_price') this.$refs.fob_price[index].$el.select();
					else if (colType == 'received_quantity') this.$refs.received_quantity[index].$el.select();
				}
			});
		},
		gotoBackOrder() {
			if (!this.items.filter(it => it.selected).length) {
				this.$toast.error('Please, Select Item(s) First.');
				return;
			}

			const query = { separator: ',' };
			query.items_str = this.items
				.filter(it => it.selected)
				.map(it => it.item_code)
				.join(query.separator);

			let routeData = this.$router.resolve({
				name: 'backOrder',
				query,
			});

			window.open(routeData.href, 'herp_backorder');
		},
		selectItem(item) {
			this.$router.push({ name: 'itemMaster', params: {}, query: { backUri: this.$route.fullPath, keyword: item.item_id } });
		},
		receiveAllItems() {
			if (this.mode == 'add') return;

			this.items.forEach(function(item) {
				item.received_quantity = item.quantity;
			});
			this.shipment.closed_yn = 'Y';
		},
		cancelAllItems() {
			if (this.mode == 'add') return;

			this.items.forEach(function(item) {
				item.received_quantity = null;
			});
			this.shipment.closed_yn = 'N';
			this.shipment.received_date = null;
		},
		selectPurchase(item) {
			//this.$router.push({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: item.po_no } });
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: item.po_no } });
			window.open(routeData.href, 'herp_purchase');
		},
		setItemClass() {
			//this.search();
		},
		async search() {
			if (!this.shipment.vendor_code) {
				this.$toast.error('Select Vendor');
				return;
			}
			this.openModal('ItemSelect');
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
		},
		deleteItems() {
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].selected) {
					if (this.items[i].sh_item_no) this.item_nos_to_delete.push(this.items[i].sh_item_no);
					this.items.splice(i, 1);
				}
			}
		},
		copyItems() {
			//console.log('copy');
			if (this.items.length > 200) {
				this.$toast.error('Too many items');
				return;
			}

			if (this.items.length > 0) {
				this.$session.set('items', this.items);
				this.$toast.success('All item is copied');
			}
		},
		pasteItems() {
			//console.log(this.$session.get('items'));
			//var copiedItems = this.$session.get('items');
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				if (!(item.org_received_quantity > 0)) item.selected = vm.allSelected;
			});
		},
		calTotal() {
			if (this.user.company_id == 'jc') return recalculateJc(this.items, this.shipment, true);
			var total_amount = 0;
			var total_quantity = 0;
			var received_amount = 0;
			var received_quantity = 0;
			var is_jc = this.user.company_id == 'jc';
			this.items.forEach(function(item) {
				// JC: Qty 1 = 1 CS. Amount = Price × Qty × Qty per carton (item.packing)
				var qpc = is_jc && item.packing > 0 ? item.packing : 1;

				if (item.quantity && item.unit_price) item.amount = item.quantity * item.unit_price * qpc;
				else item.amount = 0;

				if (item.received_quantity && item.unit_price) item.received_amount = item.received_quantity * item.unit_price * qpc;
				else item.received_amount = 0;

				item.fob_amount = item.quantity * item.fob_price * qpc;

				total_quantity += item.quantity;
				total_amount += item.amount;
				received_quantity += item.received_quantity;
				received_amount += item.received_amount;
			});
			this.shipment.total_quantity = total_quantity;
			this.shipment.total_amount = total_amount;
			this.shipment.received_quantity = received_quantity;
			this.shipment.received_amount = received_amount;
		},
		setVendor(partner) {
			//console.log(partner);
			this.shipment.vendor_name = partner.name;
		},
		parsePaymentStatus() {
			var s = this.shipment.status;
			var t = s ? s.replace(/\s/g, '') : '';
			if (!s) {
				this.payment_status = '';
				this.payment_memo = '';
			} else if (s == 'PAID' || t == '지급완료') {
				this.payment_status = 'PAID';
				this.payment_memo = '';
			} else if (s == 'UNPAID' || t == '미지급') {
				this.payment_status = 'UNPAID';
				this.payment_memo = '';
			} else if (s.indexOf('OTHERS') == 0) {
				this.payment_status = 'OTHERS';
				this.payment_memo = s.length > 7 ? s.substring(7) : '';
			} else {
				this.payment_status = 'OTHERS';
				this.payment_memo = s;
			}
			this.payment_memo = this.shipment.status_memo || (s && s.indexOf('OTHERS:') == 0 ? s.substring(7) : '');
		},
		buildPaymentStatus() {
			if (this.user.company_id != 'hairplus') return;
			if (this.payment_status == 'OTHERS') {
				this.shipment.status = 'OTHERS';
			} else if (this.payment_status == 'PAID' || this.payment_status == 'UNPAID') {
				this.shipment.status = this.payment_status;
			} else {
				this.shipment.status = null;
			}
			this.shipment.status_memo = this.payment_memo || null;
		},
		parseCbpDutyStatus() {
			var s = this.shipment.cbp_duty_status;
			this.cbp_duty_memo = this.shipment.cbp_duty_memo || (s && s.indexOf('OTHERS:') == 0 ? s.substring(7) : '');
			if (!s) {
				this.cbp_duty_sel = '';
			} else if (s == 'COMPLETED') {
				this.cbp_duty_sel = 'COMPLETED';
			} else {
				this.cbp_duty_sel = 'OTHERS';
			}
		},
		parseShippingCostStatus() {
			var s = this.shipment.shipping_cost_status;
			this.shipping_cost_memo = this.shipment.shipping_cost_memo || (s && s.indexOf('OTHERS:') == 0 ? s.substring(7) : '');
			if (!s) {
				this.shipping_cost_sel = '';
			} else if (s == 'COMPLETED') {
				this.shipping_cost_sel = 'COMPLETED';
			} else if (s == 'UNPAID') {
				this.shipping_cost_sel = 'UNPAID';
			} else {
				this.shipping_cost_sel = 'OTHERS';
			}
		},
		buildCbpDutyStatus() {
			if (this.user.company_id != 'hairplus') return;
			if (this.cbp_duty_sel == 'OTHERS') {
				this.shipment.cbp_duty_status = 'OTHERS';
			} else if (this.cbp_duty_sel == 'COMPLETED') {
				this.shipment.cbp_duty_status = 'COMPLETED';
			} else {
				this.shipment.cbp_duty_status = null;
			}
			this.shipment.cbp_duty_memo = this.cbp_duty_memo || null;
			if (this.shipment.cbp_duty === '' || this.shipment.cbp_duty === undefined) this.shipment.cbp_duty = null;
		},
		normalizeShippingCost() {
			if (this.user.company_id != 'hairplus') return;
			if (this.shipping_cost_sel == 'OTHERS') {
				this.shipment.shipping_cost_status = 'OTHERS';
			} else if (this.shipping_cost_sel == 'COMPLETED') {
				this.shipment.shipping_cost_status = 'COMPLETED';
			} else if (this.shipping_cost_sel == 'UNPAID') {
				this.shipment.shipping_cost_status = 'UNPAID';
			} else {
				this.shipment.shipping_cost_status = null;
			}
			this.shipment.shipping_cost_memo = this.shipping_cost_memo || null;
			if (this.shipment.shipping_cost === '' || this.shipment.shipping_cost === undefined) this.shipment.shipping_cost = null;
		},
		async selectShipment() {
			var param = {
				sh_no: this.shipment.sh_no,
				sort_by_received: true,
			};

			// if (this.user.company_id == 'beautyplus') param.sort_by_received = true;

			const { data } = await apiSelectShipment(param);
			//console.log(data);
			// console.log(JSON.stringify(data));

			if (this.user.company_id == 'jc') {
				data.shipmentItemList.forEach(i => initializeJcItem(i));
				initializeJcHeader(data.shipment, data.shipmentItemList);
			}
			this.shipment = data.shipment;
			this.parsePaymentStatus();
			this.parseCbpDutyStatus();
			this.parseShippingCostStatus();
			this.items = data.shipmentItemList;
			this.items.forEach(function(i) {
				if (i.received_quantity) i.org_received_quantity = i.received_quantity;
				else i.org_received_quantity = 0;

				i.remaining_quantity = i.po_quantity;
			});
			//console.log(this.items);
		},
		async checkValidity() {
			if (this.mode == 'detail') {
				const { data } = await getUpdateInfo('shipment', 'sh_no', this.shipment.sh_no);

				let upd_dt = this.shipment.upd_dt ? this.shipment.upd_dt : this.shipment.crt_dt;

				//console.log(data.update_info, upd_dt);
				if (data.update_info != null && data.update_info.upd_dt != upd_dt) {
					this.$toast.error('Data changed by ' + data.update_info.upd_name + '. Reload the page');
					return false;
				}
			}

			if (!this.shipment.application_date) {
				this.$toast.error('Empty Application Date');
				return false;
			}

			if (!this.shipment.vendor_code) {
				this.$toast.error('Empty Vendor');
				return false;
			}
			return true;
		},
		async save(stay) {
			if (await this.checkValidity()) {
				await this.submit(stay);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		receive() {
			// if (this.mode == 'add' || this.shipment.received_yn == 'Y') return;
			// if (!this.shipment.received_date) {
			// 	this.$toast.error('Empty Receipt Date');
			// 	return;
			// }
			// var r_quantity = 0;
			// this.items
			// 	.filter(i => i.received_quantity)
			// 	.forEach(function(i) {
			// 		r_quantity += i.received_quantity;
			// 	});
			// if (r_quantity == 0) {
			// 	this.$toast.error('Empty Received Quantity');
			// 	return;
			// }
			// this.shipment.receipt_process_yn = 'Y';
			// this.shipment.received_yn = 'Y';
			// this.save(true);
			//console.log('receive');
		},
		checkClosing() {
			// #3138 hairplus: Closed는 '결제 완료' 수동 표시로만 사용(입고 상태와 분리). 자동 close/un-close 프롬프트를 띄우지 않아 수동 지정한 closed_yn을 항상 보존한다.
			if (this.user.company_id == 'hairplus') return;
			if (this.shipment.total_quantity > 0 && this.shipment.total_quantity == this.shipment.received_quantity && this.shipment.closed_yn == 'N') {
				var rv1 = confirm('Received all item(s). Close this shipment?');
				if (rv1) this.shipment.closed_yn = 'Y';
				// this.$alertify.confirm('Received all item(s) Close this shipment?', () => {
				// 	this.shipment.closed_yn = 'Y';
				// });
			} else if (this.shipment.total_quantity > 0 && this.shipment.total_quantity != this.shipment.received_quantity && this.shipment.closed_yn == 'Y') {
				var rv2 = confirm('Not-Received all item(s). Un-Close this shipment?');
				if (rv2) this.shipment.closed_yn = 'N';
				// this.$alertify.confirm('Received all item(s) Close this shipment?', () => {
				// 	this.shipment.closed_yn = 'Y';
				// });
			}
		},
		async submit(stay) {
			if (this.user.company_id == 'jc') {
				const error = validateJcPrices(this.items);
				if (error) {
					this.$toast.error(error);
					return;
				}
				this.calTotal();
			}
			if (this.items.filter(i => i.received_quantity > 0).length > 0 && !this.shipment.received_date) {
				this.$toast.error('Empty Receipt Date');
				return;
			}

			var org_closed_yn = this.shipment.closed_yn;
			await this.checkClosing();
			this.buildPaymentStatus();
			this.buildCbpDutyStatus();
			this.normalizeShippingCost();
			//console.log(stay);
			var received_items = []; //Receive Quantity가 달라진 것들은 재고 반영을 해야하므로
			this.items.forEach(i => {
				//console.log(i.org_received_quantity, i.received_quantity);
				//if (!i.received_quantity) i.received_quantity = 0;
				//if (i.org_received_quantity == null) i.org_received_quantity = 0;

				//if (i.received_quantity > i.org_received_quantity) {
				//if (i.received_quantity > 0) {
				var change_quantity = 0;
				if (i.received_quantity > 0) change_quantity = i.received_quantity - i.org_received_quantity;
				else if (i.org_received_quantity > 0) change_quantity = -1 * i.org_received_quantity;

				if (change_quantity != 0) {
					received_items.push({
						item_id: i.item_id,
						//received_quantity: i.received_quantity - i.org_received_quantity,
						received_quantity: change_quantity,
						cost: i.unit_price,
						fob_price: i.fob_price,
						location_code: i.location_code,
					});
					//i.org_received_quantity = i.received_quantity;
				}
			});

			this.shipment.items = this.items;
			this.shipment.item_nos_to_delete = this.item_nos_to_delete;
			if (this.mode == 'detail' && received_items.length > 0) {
				this.shipment.received_items = received_items;
				this.shipment.receipt_process_yn = 'Y';
				this.shipment.received_yn = 'Y';
			} else this.shipment.receipt_process_yn = 'N';

			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Shipment No');
					this.shipment.closed_yn = org_closed_yn;
					return;
				}
				response = await apiInsertShipment(this.shipment);
			} else {
				response = await apiUpdateShipment(this.shipment);
			}

			var data = response.data;
			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.shipment.sh_no = data.sh_no;
						this.shipment.sh_dn = data.sh_dn;
						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Shipment -> Detail');
						//await this.selectShipment();
					}
					await this.selectShipment();
				}
			} else {
				this.shipment.closed_yn = org_closed_yn;
				this.$toast.error(data.msg);
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		addItems(items) {
			//console.log(items);
			var vm = this;
			items.forEach(function(item) {
				item.po_quantity = item.quantity;
				item.po_unit_price = item.unit_price;
				item.po_amount = item.amount;
				item.quantity = item.input_quantity;

				item.org_received_quantity = 0;
				item.received_quantity = 0;
				if (vm.user.company_id == 'jc') initializeJcItem(item, true);
				vm.items.push(item);
			});
			inputSelectOnClick();
			//console.log(items);
		},
		async index() {
			const { data } = await apiIndex();

			this.tradeTerms = data.tradeTermList;
			this.deliveryTypes = data.poDeliveryTypeList;
			this.banks = data.bankList;
			this.importLocations = data.importLocationList;
			this.locations = data.locationList;
			this.locations.unshift({ code: null, name: null });
			//console.log(this.locations);
			// this.paymentTypes = data.paymentTypeList;
			// this.holdTypes = data.poHoldTypeList;
		},
		async init() {
			await this.index();

			if (this.mode == 'detail') {
				await this.selectShipment();
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			}
			inputSelectOnClick();
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_shipment_main');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Shipment -> Add');
			this.shipment.application_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Shipment -> Detail');
			this.shipment.sh_no = this.$route.query.sh_no;
			if (!this.shipment.sh_no) {
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
		//console.log(this.backUri);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		//inputSelectOnClick();
		$(this.$refs.shipment_items).floatThead({ zIndex: 1, autoReflow: true });

		this.$nextTick(function() {
			if (this.mode == 'add') {
				this.shipment.trade_term_code = 'FOB';
				this.shipment.po_delivery_type_code = 'S';
			}
			inputSelectOnClick();
		});
	},
};
</script>

<style></style>
